const getLocale = (rootState) => rootState.i18n.locale;

export default getLocale;
